import React from 'react';
import './Auth.css';

const SetPassword = () => {
  return (
    <div className="auth-container">
      <h2>Set Password</h2>
      <form className="auth-form">
        <input type="password" placeholder="Password" required />
        <input type="password" placeholder="Repeat Password" required />
        <button type="submit" className="auth-btn">Sign Up</button>
      </form>
    </div>
  );
};

export default SetPassword; 